import { getScribeHttpClients } from '@heidi/api/client';

interface PartnerFigureUrlResponse {
  url: string;
}

/**
 * Resolves an opaque NEJM figure id to a short-lived authenticated asset URL.
 *
 * The caller immediately downloads the asset into a blob URL, so the signed
 * query never becomes an image src or enters browser telemetry.
 */
export async function getPartnerFigureUrl(figureId: string): Promise<string> {
  const response =
    await getScribeHttpClients().scribeHttpV2.get<PartnerFigureUrlResponse>(
      `/evidence/partners/nejm/figures/${encodeURIComponent(figureId)}/image`
    );
  return response.data.url;
}
